import {
  prepareAggridSettings,
  prepareResponseData,
} from '../components/AgGrid/utils';
import {
  filterAttributesPath,
  findAllAttributesPath,
} from '../constants/apiEndpoints';
import { attributeActions } from '../reducers/attribute';
import { errorAction } from '../utils/actions';
import apiService from '../utils/apiService';

export const findAllAttributes = (table, messages, inForm) => {
  return (dispatch) => {
    dispatch(attributeActions.actionStart());
    return apiService
      .get(findAllAttributesPath(table))
      .then((response) => {
        const preparedData = prepareAggridSettings(response.data);
        dispatch(
          attributeActions.setAttributeList(
            prepareResponseData(preparedData, table, inForm)
          )
        );
      })
      .catch((err) => {
        errorAction(err, attributeActions.actionError, dispatch, messages);
      });
  };
};

export const filterData = (table, attributes, limit, messages) => {
  return (dispatch) => {
    dispatch(attributeActions.actionStart());
    return apiService
      .post(filterAttributesPath(table, limit), attributes)
      .then((response) => {
        console.log('response', response.data.content);
      })
      .catch((err) => {
        errorAction(err, attributeActions.actionError, dispatch, messages);
      });
  };
};

export const filterAttributes = (filter) => {
  return (dispatch) => {
    dispatch(attributeActions.filterAttributes(filter));
  };
};

export const clearAttributeList = (type) => {
  return (dispatch) => dispatch(attributeActions.clearAttributeList(type));
};
